import React, { Component } from 'react'
import { sagaModal } from 'redux-saga-modal'
import * as messageActions from '@/models/messages/actions'
import { Form, Modal, Input, Col, Row, Table, Button, message, Select, Radio, InputNumber, AutoComplete, Checkbox } from 'antd'
import * as apis from '@/apis'
import styles from './style.module.less'
import { convRefresh } from '@/models/socket/actions';
import AddPriceForm from '@/containers/workspace/components/ChangePrice/AddItem'
import {
  showAssignWorkerSelectDialog
} from '@/models/orders/actions';

const { TextArea } = Input;
const { Option } = Select;
@Form.create()
class ReServiceDialog extends Component {
  state = {
    loading: false,
    skills: [],
    data: [],
    selectedWorker: null
  }

  columns = [
    {
      title: '费用明细',
      dataIndex: 'name',
      key: 'name',
      editable: true,
    },
    {
      title: '费用',
      dataIndex: 'price',
      key: 'price',
      editable: true,
      width: 130,
    },
    {
      title: '操作',
      dataIndex: 'control',
      width: 130,
      render: (text, record) => {
        return <a onClick={() => this.delete(record.key)}>删除</a>
      },
    },
  ]

  handleSubmit = e => {
    const { id, submitCallback, onSuccess, dispatch } = this.props
    const { getFieldValue } = this.props.form
    e.preventDefault();
    if (this.state.data.length == 0) {
      return message.error('请输入费用明细！')
    }
    if (getFieldValue('type') == 1 && !this.state.selectedWorker) {
      return message.error('请选择师傅')
    }
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      this.setState({ loading: true })
      apis.reservice(id, {
        reason: values.reason,
        type: values.type,
        workerFee: this.state.data,
        wid: this.state.selectedWorker?._id
      }).then(result => {
        message.success('提交成功')
        dispatch(messageActions.playActionAudio())
        dispatch(convRefresh())
        this.props.form.resetFields()
        onSuccess(result)
        submitCallback && submitCallback()
      }).catch(err => {
        message.error(err.message || '发生错误')
      }).finally(() => {
        this.setState({
          loading: false
        })
      })
    });
  }

  handleAddPrice = value => {
    const entity = {
      key: Math.random().toString(36).slice(-8),
      name: value.name,
      price: value.price
    }
    this.setState({
      data: [...this.state.data, entity],
    })
  }
  delete(key) {
    this.setState({
      data: this.state.data.filter(item => item.key !== key)
    })
  }
  getColumns = () => {
    return this.columns.map(col => {
      return col
    })
  }
  onTypeChange = async (e) => {
    const { id, order, dispatch } = this.props
    if (e.target.value == 1) {
      dispatch(showAssignWorkerSelectDialog({
        title: '查看报价/指派师傅',
        id: id,
        orderMap: order,
        order: order.toJS(),
        showBuyoutPrice: false,
        onSuccess: (val) => {
          this.setState({
            selectedWorker: val?.worker
          })
        }
      }));
    } else {
      this.setState({
        selectedWorker: null
      })
    }
  }

  render() {
    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form
    const columns = this.getColumns()

    function onChange(value) {
      setFieldsValue({ reason: value })
    }
    return (
      <div className={styles.wrap} >
        <div className={styles.addForm}>
          <AddPriceForm onSubmit={this.handleAddPrice} />
        </div>

        <Form labelCol={{
          span: 5
        }}
          wrapperCol={{
            span: 19,
          }}
          layout="horizontal" onSubmit={this.handleSubmit}>
          <div className={styles.itemType}>
            <Form.Item
              label="类型"
              required
              extra={(
                <>
                  {(
                    getFieldValue('type') == 1 &&
                    this.state.selectedWorker
                  ) &&
                    <div style={{ color: '#333' }}>
                      {this.state.selectedWorker?.realname}--{this.state.selectedWorker?.user?.mobile}
                    </div>}
                </>
              )}
            >
              {getFieldDecorator('type', {
                // initialValue: 1,
                rules: [
                  {
                    required: true,
                    message: '请选择类型',
                  },
                ],
              })(
                <Radio.Group
                  onChange={this.onTypeChange}
                >
                  <Radio value={1}>选择师傅</Radio>
                  <Radio value={2}>转为一口价工单</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </div>

          <div style={{ marginBottom: 15 }}>
            <Table
              dataSource={this.state.data}
              locale={{ emptyText: '暂无费用明细' }}
              columns={columns}
              rowClassName="editable-row"
              size="middle"
              pagination={false}
            />
          </div>


          <Form.Item label="常用原因">
            <Select
              showSearch
              style={{ width: 290 }}
              placeholder="快速选择原因"
              optionFilterProp="children"
              onChange={onChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="客户收到配件，请再次上门。">客户收到配件，请再次上门。</Option>
              <Option value="物流再次送货，请再次上门。">物流再次送货，请再次上门。</Option>
              <Option value="上次没处理好，请再次上门。">上次没处理好，请再次上门。</Option>
              <Option value="遗忘返厂配件，请再次上门。">遗忘返厂配件，请再次上门。</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="上门原因"
            required>
            {getFieldDecorator('reason', {
              rules: [
                {
                  required: true,
                  message: '请输入上门原因',
                },
              ],
            })(
              <TextArea style={{ width: 300 }} rows={4} autoFocus placeholder="请输入上门原因" />
            )}
          </Form.Item>

          <Form.Item wrapperCol={{
            offset: 6,
            span: 16,
          }}>
            <Button type="primary" style={{ width: 100 }} htmlType="submit">提交</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const ReServiceInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title="再次上门"
    destroyOnClose
    footer={null}
    width={500}
    visible={isOpen}
    maskClosable={false}
    onCancel={hide}
    zIndex={995}
    mask={false}
    wrapClassName="order-detail-modal-wrap"
    maskStyle={{ position: 'absolute' }}
    getContainer={() => document.getElementById('order-detail-wrap') || window}
  >
    <ReServiceDialog onSuccess={hide} submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'RE_SERVICE_DIALOG',
})(ReServiceInfoDialog)
